<mat-card class="horiz-float-bar-card" *ngIf="isVisible()">
  <div class="horiz-float-bar-div">
    <div class="horiz-float-bar-button-div" #colorButton>
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below" matTooltipShowDelay="2000"
        [disabled]="isColorPickerActive()"
        (click)="onColorClick()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconColor()}">color_lens</mat-icon>
      </button>
    </div>
    <span><mat-divider [vertical]="true" style="height: 100%"></mat-divider></span>
    <div class="horiz-float-bar-button-div">
      <button mat-icon-button [matTooltip]="'MAP.PENCIL' | translate" matTooltipPosition="below" matTooltipShowDelay="2000"
        [disabled]="isFreeDrawDisabled()"
        (click)="onPencilClick()">
        <mat-icon [ngClass]="isToolActive(TOOL_PENCIL) ? 'svg-icon-selected' : (isFreeDrawDisabled() ? 'svg-icon-disabled' : 'svg-icon')">edit</mat-icon>
      </button>
    </div>
    <div class="horiz-float-bar-button-div">
      <button mat-icon-button [matTooltip]="'MAP.BRUSH' | translate" matTooltipPosition="below" matTooltipShowDelay="2000" 
        [disabled]="isFreeDrawDisabled()"
        (click)="onBrushClick()">
        <mat-icon [ngClass]="isToolActive(TOOL_BRUSH) ? 'svg-icon-selected' : (isFreeDrawDisabled() ? 'svg-icon-disabled' : 'svg-icon')">brush</mat-icon>
      </button>
    </div>
    <div class="horiz-float-bar-button-div">
      <button mat-icon-button [matTooltip]="'MAP.RECTANGLE'| translate" matTooltipPosition="below" matTooltipShowDelay="2000" 
        [disabled]="isFreeDrawDisabled()"
        (click)="onRectangleClick()">
        <mat-icon [ngClass]="isToolActive(TOOL_RECTANGLE) ? 'svg-icon-selected' : (isFreeDrawDisabled() ? 'svg-icon-disabled' : 'svg-icon')">crop_3_2</mat-icon>
      </button>
    </div>
    <div class="horiz-float-bar-button-div"><button mat-icon-button [matTooltip]="'MAP.CIRCLE'| translate" matTooltipPosition="below" matTooltipShowDelay="2000"
        [disabled]="isFreeDrawDisabled()"
        (click)="onCircleClick()">
        <mat-icon [ngClass]="isToolActive(TOOL_CIRCLE) ? 'svg-icon-selected' : (isFreeDrawDisabled() ? 'svg-icon-disabled' : 'svg-icon')">panorama_fish_eye</mat-icon>
      </button>
    </div>
    <div class="horiz-float-bar-button-div"><button mat-icon-button [matTooltip]="'MAP.POLYGON'| translate" matTooltipPosition="below" matTooltipShowDelay="2000"
      [disabled]="isFreeDrawDisabled()"
      (click)="onPolygonClick()">
      <mat-icon [ngClass]="isToolActive(TOOL_POLYGON) ? 'svg-icon-selected' : (isFreeDrawDisabled() ? 'svg-icon-disabled' : 'svg-icon')">bookmark_border</mat-icon>
    </button>
  </div>
    <span><mat-divider [vertical]="true" style="height: 100%"></mat-divider></span>
    <div class="horiz-float-bar-button-div">
      <button mat-icon-button [matTooltip]="'MAP.ERASER'| translate" matTooltipPosition="below" matTooltipShowDelay="2000" 
        [disabled]="isFreeDrawDisabled()"
        (click)="onEraserClick()">
        <mat-icon [ngClass]="isToolActive(TOOL_ERASE) ? 'svg-icon-selected' : (isFreeDrawDisabled() ? 'svg-icon-disabled' : 'svg-icon')">delete</mat-icon>
      </button>
    </div>
  </div>
</mat-card>